import React from "react";
import { getNutritionalProducts, getVitaminsProducts } from "../../../helpers";
import MenuBadge from "../MenuBadge";
import * as S from "../styles";

var NutritionalSubMenu = function NutritionalSubMenu(_ref) {
  var e = _ref.links,
      t = _ref.cards,
      a = _ref.promos,
      n = _ref.handleSubLinkClick,
      r = _ref.renderLinkAs,
      l = _ref.filteredPipLink,
      i = _ref.handleFilteredPipLinkClick;
  var c = getNutritionalProducts(e),
      u = getVitaminsProducts(e);
  return React.createElement(React.Fragment, null, React.createElement(S.NutritionSubMenuSectionWrapper, {
    dataTestId: "nutritional-tests-desktop-links"
  }, React.createElement(S.SubHeaderContainer, null, React.createElement(S.SubMenuSubHeader, null, "Tests")), c.map(function (e) {
    return React.createElement("div", null, React.createElement(S.ProductLink, {
      key: e.slug,
      "data-testid": e.slug,
      href: e.url,
      onClick: function onClick() {
        return n(e.tags[0], e.label);
      },
      as: r || void 0
    }, e.label, e.badge ? React.createElement(MenuBadge, {
      iconText: e.badge
    }) : null));
  })), React.createElement("div", null, React.createElement(S.SubHeaderContainer, {
    dataTestId: "nutritional-vitamins-desktop-links"
  }, React.createElement(S.SubMenuSubHeader, null, "Vitamins & Supplements")), u.map(function (e) {
    return React.createElement("div", null, React.createElement(S.ProductLink, {
      key: e.slug,
      "data-testid": e.slug,
      href: e.url,
      onClick: function onClick() {
        return n(e.tags[0], e.label);
      },
      as: r || void 0
    }, e.label));
  })), React.createElement(S.ShopAllNutritionFilteredPipWrapper, null, React.createElement(S.ShopAllFilteredPipButton, {
    href: l.url,
    onClick: function onClick() {
      return i(l);
    }
  }, "Shop all " + l.categoryName)), React.createElement(S.SubMenuSectionWrapper, {
    dataTestId: "nutritional-desktop-cards"
  }, t.map(function (e) {
    return React.createElement(S.ProductCard, Object.assign({}, e, {
      key: e.slug,
      testIDPrefix: "cards"
    }));
  })), React.createElement(S.SubMenuSectionWrapper, {
    dataTestId: "nutritional-desktop-promos"
  }, a.map(function (e) {
    return React.createElement(S.PromoCard, Object.assign({
      key: e.product.slug
    }, e));
  })));
};

export default NutritionalSubMenu;